module.exports = new __parcel__URL__("Bronze2.75352fd0.png").toString();